import script from "./AppLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLink.vue?vue&type=script&setup=true&lang=js"

import "./AppLink.vue?vue&type=style&index=0&id=b573e34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b573e34c"]])

export default __exports__